import React from 'react';
import { Link } from 'react-router-dom';
import ZemedicLogo from './ZemedicLogo';

const Footer = () => {
  return (
    <footer className="bg-black text-gray-300 border-t border-gray-800">
      <div className="container-custom py-16">
        <div className="grid md:grid-cols-12 gap-8 mb-8">
          {/* Column 1 - About */}
          <div className="md:col-span-5">
            <Link to="/" className="inline-block mb-6">
              <ZemedicLogo className="h-10 w-auto" fill="#ffffff" />
            </Link>
            <p className="text-gray-400 mb-6 max-w-md leading-relaxed">
              ZemedicAI delivers cutting-edge AI-powered medical diagnostic tools 
              designed specifically for the unique healthcare challenges across Africa.
            </p>
            <div className="mb-6">
              <p className="text-gray-400 flex items-center">
                <svg className="h-5 w-5 mr-2 text-purple-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                </svg>
                <a href="mailto:hello@zemaai.com" className="hover:text-purple-400 transition-colors">
                  hello@zemaai.com
                </a>
              </p>
            </div>
            <div className="flex space-x-4">
              <a href="#" className="text-gray-500 hover:text-purple-400 transition-colors">
                <svg className="h-6 w-6" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M24 4.557c-.883.392-1.832.656-2.828.775 1.017-.609 1.798-1.574 2.165-2.724-.951.564-2.005.974-3.127 1.195-.897-.957-2.178-1.555-3.594-1.555-3.179 0-5.515 2.966-4.797 6.045-4.091-.205-7.719-2.165-10.148-5.144-1.29 2.213-.669 5.108 1.523 6.574-.806-.026-1.566-.247-2.229-.616-.054 2.281 1.581 4.415 3.949 4.89-.693.188-1.452.232-2.224.084.626 1.956 2.444 3.379 4.6 3.419-2.07 1.623-4.678 2.348-7.29 2.04 2.179 1.397 4.768 2.212 7.548 2.212 9.142 0 14.307-7.721 13.995-14.646.962-.695 1.797-1.562 2.457-2.549z" />
                </svg>
              </a>
              <a href="#" className="text-gray-500 hover:text-purple-400 transition-colors">
                <svg className="h-6 w-6" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M12 0c-6.626 0-12 5.373-12 12 0 5.302 3.438 9.8 8.207 11.387.599.111.793-.261.793-.577v-2.234c-3.338.726-4.033-1.416-4.033-1.416-.546-1.387-1.333-1.756-1.333-1.756-1.089-.745.083-.729.083-.729 1.205.084 1.839 1.237 1.839 1.237 1.07 1.834 2.807 1.304 3.492.997.107-.775.418-1.305.762-1.604-2.665-.305-5.467-1.334-5.467-5.931 0-1.311.469-2.381 1.236-3.221-.124-.303-.535-1.524.117-3.176 0 0 1.008-.322 3.301 1.23.957-.266 1.983-.399 3.003-.404 1.02.005 2.047.138 3.006.404 2.291-1.552 3.297-1.23 3.297-1.23.653 1.653.242 2.874.118 3.176.77.84 1.235 1.911 1.235 3.221 0 4.609-2.807 5.624-5.479 5.921.43.372.823 1.102.823 2.222v3.293c0 .319.192.694.801.576 4.765-1.589 8.199-6.086 8.199-11.386 0-6.627-5.373-12-12-12z" />
                </svg>
              </a>
              <a href="#" className="text-gray-500 hover:text-purple-400 transition-colors">
                <svg className="h-6 w-6" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M22.675 0h-21.35c-.732 0-1.325.593-1.325 1.325v21.351c0 .731.593 1.324 1.325 1.324h11.495v-9.294h-3.128v-3.622h3.128v-2.671c0-3.1 1.893-4.788 4.659-4.788 1.325 0 2.463.099 2.795.143v3.24l-1.918.001c-1.504 0-1.795.715-1.795 1.763v2.313h3.587l-.467 3.622h-3.12v9.293h6.116c.73 0 1.323-.593 1.323-1.325v-21.35c0-.732-.593-1.325-1.325-1.325z" />
                </svg>
              </a>
              <a href="#" className="text-gray-500 hover:text-purple-400 transition-colors">
                <svg className="h-6 w-6" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M19.615 3.184c-3.604-.246-11.631-.245-15.23 0-3.897.266-4.356 2.62-4.385 8.816.029 6.185.484 8.549 4.385 8.816 3.6.245 11.626.246 15.23 0 3.897-.266 4.356-2.62 4.385-8.816-.029-6.185-.484-8.549-4.385-8.816zm-10.615 12.816v-8l8 3.993-8 4.007z" />
                </svg>
              </a>
            </div>
          </div>
          
          {/* Column 2 - Solutions */}
          <div className="md:col-span-2">
            <h3 className="text-white font-semibold text-lg mb-5">Solutions</h3>
            <ul className="space-y-3">
              <li><Link to="/analyze/encounter" className="text-purple-300 hover:text-purple-200 transition-colors">Screening Encounter</Link></li>
              <li><Link to="/solutions/xray" className="text-gray-400 hover:text-purple-400 transition-colors">X-Ray Analysis</Link></li>
              <li><Link to="/analyze/retina" className="text-gray-400 hover:text-purple-400 transition-colors">Retinal Fundus Screening</Link></li>
              <li><Link to="/analyze/foot" className="text-gray-400 hover:text-purple-400 transition-colors">Diabetic Foot Assessment</Link></li>
              <li><Link to="/solutions/skin" className="text-gray-400 hover:text-purple-400 transition-colors">Skin Lesion Detection</Link></li>
              <li><Link to="/solutions/ct-scan" className="text-gray-400 hover:text-purple-400 transition-colors">Breast Ultrasound</Link></li>
              <li><Link to="/analyze/fetal-plane" className="text-gray-400 hover:text-purple-400 transition-colors">Fetal Ultrasound Plane</Link></li>
            </ul>
          </div>
          
          {/* Column 3 - Deployment */}
          <div className="md:col-span-2">
            <h3 className="text-white font-semibold text-lg mb-5">Products</h3>
            <ul className="space-y-3">
              <li><Link to="/preorder" className="text-gray-400 hover:text-purple-400 transition-colors">Solar-Powered Booths</Link></li>
              <li><Link to="/preorder" className="text-gray-400 hover:text-purple-400 transition-colors">SDK Integration</Link></li>
              <li><Link to="/deployment/solar-booths" className="text-gray-400 hover:text-purple-400 transition-colors">Deployment Options</Link></li>
            </ul>
          </div>
          
          {/* Column 4 - Company */}
          <div className="md:col-span-3">
            <h3 className="text-white font-semibold text-lg mb-5">Company</h3>
            <ul className="space-y-3">
              <li><Link to="/about" className="text-gray-400 hover:text-purple-400 transition-colors">About Us</Link></li>
              <li><Link to="/partners" className="text-gray-400 hover:text-purple-400 transition-colors">Partners</Link></li>
              <li><Link to="/how-it-works" className="text-gray-400 hover:text-purple-400 transition-colors">How It Works</Link></li>
              <li><Link to="/contact" className="text-gray-400 hover:text-purple-400 transition-colors">Contact Us</Link></li>
            </ul>
          </div>
        </div>
        
        {/* Newsletter */}
        <div className="border-t border-gray-800 pt-8 pb-12">
          <div className="flex flex-col md:flex-row md:items-center justify-between">
            <div className="mb-6 md:mb-0">
              <h4 className="text-white font-semibold text-lg mb-2">Stay updated</h4>
              <p className="text-gray-400">Subscribe to our newsletter for the latest updates</p>
            </div>
            <div className="flex flex-col sm:flex-row space-y-3 sm:space-y-0 sm:space-x-3 w-full md:w-auto">
              <input 
                type="email" 
                placeholder="Your email address" 
                className="px-4 py-3 bg-gray-800 border border-gray-700 rounded-lg text-white focus:outline-none focus:ring-2 focus:ring-purple-500 w-full md:w-64"
              />
              <button className="px-6 py-3 bg-gradient-to-r from-purple-600 to-indigo-600 hover:from-purple-700 hover:to-indigo-700 text-white rounded-lg transition-colors uppercase tracking-wide text-sm">
                Subscribe
              </button>
            </div>
          </div>
        </div>
        
        {/* Bottom section */}
        <div className="border-t border-gray-800 pt-8 flex flex-col md:flex-row justify-between items-center">
          <p className="text-gray-500 text-sm">
            &copy; {new Date().getFullYear()} ZemedicAI. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;